import React, { useEffect, useState } from 'react';
import { RegWallContainer } from '@surfline/quiver-react';
import { TABLET_LARGE_WIDTH, trackEvent } from '@surfline/web-common';
import SignIn from '../SignIn';
import LearnMore from '../LearnMore';
import Home from '../Home';
import {
  SIGN_IN,
  LEARN_MORE,
  HOME,
  SERVED_POPUP,
  FORCED_REGISTRATION,
} from '../../../../common/constants';

const trackPopupServed = () =>
  trackEvent(SERVED_POPUP, {
    popupName: FORCED_REGISTRATION,
    category: FORCED_REGISTRATION,
    platform: 'web',
    isMobileView: window.innerWidth <= TABLET_LARGE_WIDTH,
  });

/**
 * @function MeterBottomSheetRegWall
 * @param {object} props
 * @return {JSX.Elemet}
 */
const MeterBottomSheetRegWall = () => {
  useEffect(() => {
    trackPopupServed();
  }, []);

  const [form, setForm] = useState(HOME);

  const renderForm = () => {
    switch (form) {
      case SIGN_IN:
        return <SignIn setForm={setForm} />;
      case LEARN_MORE:
        return <LearnMore setForm={setForm} />;
      default:
        return <Home setForm={setForm} />;
    }
  };

  return (
    <div className="sl-meter-bottom-sheet">
      <RegWallContainer>
        <div className="sl-meter-bottom-sheet__modal">
          {form === HOME ? null : (
            <button
              className="sl-meter-bottom-sheet__modal__action__back"
              onClick={() => setForm(HOME)}
              type="button"
            >
              <div className="sl-meter-bottom-sheet__modal__action__arrow" />
              <span>BACK</span>
            </button>
          )}
          {renderForm()}
        </div>
      </RegWallContainer>
    </div>
  );
};

export default MeterBottomSheetRegWall;
